// store id's
export const APPLICATION_STORE = 'application';
export const VARIABLE_STORE = 'variable';
export const WORKFLOW_STORE = 'workflow';
export const LOCALIZATION_STORE = 'localization';
export const MODULE_SETTINGS_STORE = 'moduleSettings';
